import { useSuspenseQuery } from '@tanstack/react-query'

import { getNacionalidadePrincipalId } from '@/features/proposta/shared/domain/nacionalidade'
import { GetNacionalidadesService } from '@/http/get-nacionalidades.service'
import { nacionalidadeClienteKeys } from '@/utils/cliente-query-keys'

const SEIS_HORAS = 1000 * 60 * 60 * 6

export const useSuspenseNacionalidade = () => {
  const query = useSuspenseQuery({
    queryKey: nacionalidadeClienteKeys.lista(),
    queryFn: async () => new GetNacionalidadesService().execute().then((res) => res.data),
    staleTime: SEIS_HORAS,
  })

  return {
    ...query,
    nacionalidadePrincipalId: getNacionalidadePrincipalId(query.data),
  }
}
